var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlaylistAdd = function SvgPlaylistAdd(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.5 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM7.5 5.813v3.375M9.187 7.5H5.812M15 10h5M15 5h5M20 15H9M4 15h1M4 20h1M20 20H9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlaylistAdd);
export default ForwardRef;